
import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Button, Flex } from "antd"
import styles from "./index.module.css"
import { OTHER_OPTIONS } from "./constants"

const getOtherFilters = (selectedOptions) => ({
  accessibility_enabled: selectedOptions.includes("Accessible"),
  alcohol_allowed: selectedOptions.includes("Alcohol is Allowed"),
  children_allowed: selectedOptions.includes("Child Friendly")
})

export default function OtherFilterDropdown({ value = [], onChange, updateSearchFilters }) {
  const { t } = useTranslation()

  const handleSelect = (option) => {
    let newValue
    if (value.includes(option)) {
      newValue = value.filter((o) => o !== option)
    } else {
      newValue = [...value, option]
    }
    onChange(newValue)
    updateSearchFilters(getOtherFilters(newValue))
  }

  const handleClear = () => {
    onChange([])
    updateSearchFilters(getOtherFilters([]))
  }

  return (
    <div className={styles.dropdownContent}>
      <Flex gap={8} wrap="wrap" className="mb-s">
        {OTHER_OPTIONS.map((option) => (
          <Button
            key={option}
            type={value.includes(option) ? "primary" : "default"}
            shape="round"
            onClick={() => handleSelect(option)}
          >
            {option}
          </Button>
        ))}
      </Flex>
      <Button type="link" onClick={handleClear}>
        {t('filterTags.clear')}
      </Button>
    </div>
  )
}

OtherFilterDropdown.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  updateSearchFilters: PropTypes.func.isRequired
}



